var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main home"},[_c('div',{staticClass:"w"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.news.newsTitle)+" ")]),(_vm.news)?_c('div',{staticClass:"editor-content-view",style:(this.GLOBAL.isMobile? 'width: 96%': 'width: 60%'),domProps:{"innerHTML":_vm._s(_vm.news.newsContent)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }